import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { FacilitiesComponent } from './facilities.component';
import { UbsViewContainersModule, ViewContainersService } from '@urbannex/view-containers';
import { NbMenuItem } from '@nebular/theme';
import { FacilityComponent } from './facility/facility.component';

export const facilityroutes:Routes = [
  {
    path:"",
    component:FacilitiesComponent,
    data:{
      breadcrumb:"Facilities"
    }
  },
  {
    path:'facility',
    component:FacilityComponent,
    data:{
      breadcrumb:"Facility"
    }
  },
  {
    path:'facility/:facilityId/facility-overview/:event',
    component:FacilityComponent,
    data:{
      breadcrumb:"Facility",
      paramKey:"facilityId;"
    }
  },
  {
    path:'facility/:facilityId/facility-locations/:event',
    component:FacilityComponent,
    data:{
      breadcrumb:"Facility",
      paramKey:"facilityId;"
    }
  },
  {
    path:'facility/:facilityId/receive-inventory-order/:event',
    component:FacilityComponent,
    data:{
      breadcrumb:"Facility",
      paramKey:"facilityId;"
    }
  },
  {
    path:'facility/:facilityId/receive-inventory-product/:event',
    component:FacilityComponent,
    data:{
      breadcrumb:"Facility",
      paramKey:"facilityId;"
    }
  },
  {
    path:'facility/:facilityId/facility-locations/:event',
    component:FacilityComponent,
    data:{
      breadcrumb:"Facility",
      paramKey:"facilityId;"
    }
  },
  {
    path:'facility/:facilityId/inventory-products/:event',
    component:FacilityComponent,
    data:{
      breadcrumb:"Facility",
      paramKey:"facilityId;"
    }
  },
  {
    path:'facility/:facilityId/inventory-items/:event',
    component:FacilityComponent,
    data:{
      breadcrumb:"Facility",
      paramKey:"facilityId;"
    }
  }
]

const MENU_ITEMS:NbMenuItem[] = [
    {title:"Warehouses",group:true},
    {
      title:"List Warehouses",
      icon:{icon:"list-outline",pack:'eva'},
      link:"/admin/facilities"
    },
    {
      title:"New Warehouse",
      icon:{icon:"plus-outline",pack:'eva'}
    },

]

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    RouterModule.forChild(facilityroutes),
    UbsViewContainersModule
  ]
})
export class FacilitiesRoutingModule { 
  headerTitle:string = "Facilities Management";
  path:string = "facilities";
  menuTag:string = "facilitiesMenu"
  menuAndTitleOptions = {path:this.path,menuItems:MENU_ITEMS,headerTitle:this.headerTitle,menuTag:this.menuTag};
  
  constructor(private viewContainerService:ViewContainersService){
      console.log("UpdateMenuTitle",this.menuAndTitleOptions)
      this.viewContainerService.menuAndTitleOptions$.next([... this.viewContainerService.menuAndTitleOptions$.getValue(),this.menuAndTitleOptions]);
      this.viewContainerService.activeMenuTag$.next(this.menuTag);
    }

}
